import {BaseComponentProcessor} from "../../../utils/processor/BaseComponentProcessor";

/**
 * Code processor
 */
export class NativeComponentProcessor extends BaseComponentProcessor {

    /**
     * Construct parent
     * @param props
     */
    constructor(...props) {
        super(...props);
    }


    /**
     * Process incoming event
     * @param event
     * @param data
     */
    // eslint-disable-next-line no-unused-vars
    processEvent(event, data) {
        // Reset modals
        this.context.currentDiagram?.hideModals?.();

        // Call handler
        this.context.currentDiagram.callHandler(this.block.id, event, data);
    }
}
